export const ImageCache = {};
//# sourceMappingURL=cache.js.map